"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.productionMeasure = exports.nonProductionMeasure = void 0;
var perf_1 = __importDefault(require("./perf"));
exports.nonProductionMeasure = function (name, fn) { return function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    perf_1.default.mark(name + ":start");
    var result = fn.apply(void 0, __spread(args));
    perf_1.default.mark(name + ":end");
    perf_1.default.measure(name, name + ":start", name + ":end");
    return result;
}; };
exports.productionMeasure = function (_name, fn) { return fn; };
var measure = process.env.NODE_ENV === 'production'
    ? exports.productionMeasure
    : exports.nonProductionMeasure;
exports.default = measure;
